
export const ACTION_SAVE_QR_CODES_PAGINATED = 'ACTION_SAVE_QR_CODES_PAGINATED';

export const ACTION_SAVE_QR_CODE_DETAILS = 'ACTION_SAVE_QR_CODE_DETAILS';
